import { FC } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import styles from './ReviewsList.module.scss';
import ReviewCard from '../review-card/ReviewCard';
import { IReviews, IReviewsData } from '@/interfaces/reviews.interface';
import { IBookPageForms } from '@/interfaces/bookPageForms';

interface IReviewsList {
  reviews: IReviews;
  isReviewsPage?: boolean;
  setIsFormsActive?: React.Dispatch<React.SetStateAction<IBookPageForms>>;
}

const ReviewsList: FC<IReviewsList> = ({ reviews, isReviewsPage, setIsFormsActive }) => {
  const reviewsData = !isReviewsPage ? reviews.data.slice(0, 4) : reviews.data;

  const router = useRouter();
  const pathName = router.asPath;

  const handleReviewFormActive = () => {
    if (setIsFormsActive) {
      setIsFormsActive((prevState: IBookPageForms) => ({ ...prevState, reviewFrom: true }));
    }
  };

  return (
    <div className={isReviewsPage ? `${styles.reviewsList}` : `${styles.reviewsList} ${styles.reviewsList_mainPage}`}>
      {reviewsData.map((review: IReviewsData) => (
        <ReviewCard key={review.id} name={review.name} message={review.message} />
      ))}

      {!isReviewsPage && (
        <div className={styles.reviewsList__controls}>
          <a href="#reviewForm" className={styles.reviewsList__btn} onClick={handleReviewFormActive}>
            Добавить отзыв
          </a>
          {reviews.data.length > 4 && (
            <Link prefetch={false} href={`${pathName}reviews/`} className={`${styles.reviewsList__btn} ${styles.reviewsList__btn_review}`}>
              Посмотреть все отзывы
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewsList;
